/**
 * @generated SignedSource<<9b4137f198a144be8bdec1d3d3b5c0c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOneloginOauthKeyInput = {
  email?: string | null;
  issuer?: string | null;
  clientMutationId?: string | null;
};
export type createOneloginOauthKeyMutation$variables = {
  input: CreateOneloginOauthKeyInput;
};
export type createOneloginOauthKeyMutation$data = {
  readonly createOneloginOauthKey: {
    readonly key: string | null;
    readonly oneloginClientId: string | null;
    readonly oneloginUrl: string | null;
  } | null;
};
export type createOneloginOauthKeyMutation = {
  variables: createOneloginOauthKeyMutation$variables;
  response: createOneloginOauthKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOneloginOauthKeyPayload",
    "kind": "LinkedField",
    "name": "createOneloginOauthKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneloginClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneloginUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOneloginOauthKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOneloginOauthKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fac9b47bad358db08343b575291f40a9",
    "id": null,
    "metadata": {},
    "name": "createOneloginOauthKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOneloginOauthKeyMutation(\n  $input: CreateOneloginOauthKeyInput!\n) {\n  createOneloginOauthKey(input: $input) {\n    key\n    oneloginClientId\n    oneloginUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b656fd5682af6552258e76eb64e1f3f";

export default node;
